import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface Ilanguage {
  languages: Ilang[];
}

export interface Ilang {
  id: string;
  langCode: string;
  name: string;
  optinLang: string;
}

@Injectable({
  providedIn: 'root'
})
export class GetLanguagesService {
  _languages: Ilang[];
  constructor(private _http: HttpClient) {
  }

  get languages() {
    return this._languages;
  }

  getLanguages(): Promise<Ilang[]> {
    return new Promise((resolve, reject) => {
      this._http.get(`${environment.servicePath}/address/languages`).subscribe(
        (res: Ilanguage) => {
          this._languages = res.languages;
          resolve(res.languages);
        },
        (err: any) => {
          reject(err);
        }
      );
    });
    //return this.httpclient.get(environment.servicePath + '/address/languages')
  }


  getLangName(langCode: string): string {
    let lang = this._languages
      .filter(lang => lang.langCode === langCode)
      .map(lang => lang.name);
    if (lang)
      return lang[0];
    else
      return "";
  }

}
